<app-layout>
<div class="card border-left" >
  <div class="col-12 md:col-12 d-flex justify-content-between flex-wrap">
    <span class="h4 fw-bold text-primary">
      <i class="fa fa-graduation-cap me-2"></i>
      Pestforce Academy
    </span>
  </div>

  <div class="py-5">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-3 mb-4" *ngFor="let course of Courses()">
        <div class="card h-100 shadow-sm course-card">
          <div class="card-img-wrapper position-relative">
            <img [src]="course?.miniature ?? 'https://i.sstatic.net/y9DpT.jpg'" class="card-img-top"
              [alt]="course.title">
          </div>

          <div class="card-body">
            <h5 class="card-title text-dark">{{ course.name }}</h5>
            <p class="card-text text-muted">{{ course.description }}</p>

            <div class="d-flex justify-content-between mb-1">
              <p-badge *ngIf="!course.cost" value="Curso Gratuito" severity="info" />
            </div>

            <div class="mt-3">
              <div class="d-flex justify-content-between mb-1">
                <small style="font-size: 15px;">
                  <span class="fw-bold text-dark">
                    <i class="fa fa-clock-o" aria-hidden="true"></i> Duración:{{' '}}
                  </span>

                  {{course.duration}}
                </small>
              </div>

              <div class="d-flex justify-content-between mb-1">
                <small style="font-size: 15px;">
                  <span class="fw-bold text-dark">
                    <i class="fa fa-money" aria-hidden="true"></i> Precio:{{' '}}
                  </span>
                         {{ course?.mount | number: '1.2-2' }}
                </small>
              </div>
            </div>

            <div class="mt-2">
              <small style="font-size: 15px;" class="fw-bold text-dark">{{course.label}}</small>
            </div>
          </div>

          <div class="card-footer bg-white border-top-0">
            <div class="d-flex justify-content-center">
              <button (click)="view(course)" class="btn btn-sm btn-primary w-100">Ver curso</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="closeVideoModal()">
          </button>
        </div>

        <div class="modal-body p-0">
          <div class="ratio ratio-16x9">
            <iframe *ngIf="currentVideoUrl" [src]="currentVideoUrl" title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</app-layout>